import {
  Box,
  HStack,
  Icon,
  IconButton,
  Text,
  Image,
  Button,
  Pressable,
  Spinner,
  Avatar,
  HamburgerIcon,
} from "native-base";
import React, { useState, useEffect } from "react";
import { Tooltip } from "@mui/material";
import { MaterialIcons } from "@native-base/icons";
import logo from "../assets/logoW.svg";
import { useHistory, useParams } from "react-router-dom";
import { compose } from "redux";
import { connect, useDispatch, useSelector } from "react-redux";
import { Logout } from "../Redux/actions";
import { Menu } from "native-base";
import firebase from "firebase/app";
import "firebase/auth";
import { isLoaded } from "react-redux-firebase";

const Header = ({ auth, profile }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isAdmin, setIsAdmin] = useState(false);

  // Detect current venue from URL params (works on /editBusiness/:id, /Orders/:id, etc.)
  const currentPath = typeof window !== "undefined" ? window.location.pathname : "";
  const venueIdMatch = currentPath.match(/\/(editBusiness|Orders|Manage|Bussiness|reservations)\/([^/]+)/);
  const currentVenueId = venueIdMatch ? venueIdMatch[2] : null;

  // Load the current venue's Business doc to check bizStripeId
  const businessData = useSelector(({ firestore: { data } }) => data.Business);
  const currentVenue = currentVenueId && businessData ? businessData[currentVenueId] : null;
  const hasDoshii = currentVenue?.integration?.type === 'doshii' && currentVenue?.integration?.status === 'active';
  const showEnablePayments = currentVenue && !currentVenue.bizStripeId && !hasDoshii;

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        user.getIdTokenResult().then((result) => {
          setIsAdmin(!!result.claims.admin);
        }).catch(() => setIsAdmin(false));
      } else {
        setIsAdmin(false);
      }
    });
    return () => unsubscribe();
  }, []);
  return (
    <>
      <div id="header-div">
        <Box safeAreaTop bg="#6200ee" />
        {/* <Button onPress={()=>dispatch(TestAPI())}>test</Button> */}
        <HStack
          bg="coolGray.900"
          px="3"
          py="3"
          justifyContent="space-between"
          alignItems="center"
          w="100%"
        >
          <HStack alignItems="center">
            <Pressable onPress={() => history.push("/")} aria-label="Piatto home">
              <Image
                source={{ uri: logo }}
                resizeMode="contain"
                size={100}
                h="50px"
                alt="Piatto home"
              />
            </Pressable>
          </HStack>
          <Box as="nav" aria-label="Main navigation">
          <HStack space={3} alignItems="center">
            {isAdmin && (
              <Pressable onPress={() => history.push("/admin/dashboard")}>
                <Text color="yellow.400" fontWeight="bold" fontSize="sm">
                  Admin Dashboard
                </Text>
              </Pressable>
            )}
            {!auth.uid && (
              <Pressable onPress={() => history.push("/claim-venue/search")}>
                <Text color="red.500" fontWeight="bold" fontSize="sm">
                  Claim Your Venue
                </Text>
              </Pressable>
            )}
            {/* Spinner only while profile is loading and admin status unknown */}
            {!profile.isLoaded && !isAdmin && !auth.uid && (
              <Spinner size={"sm"} />
            )}

            {/* Always show logout + avatar when authenticated — never blocked by profile loading */}
            {auth.uid && (
              <HStack space={2} alignItems="center">
                {/* Enable Payments CTA — only when current venue has no Stripe account */}
                {showEnablePayments && (
                  <Pressable
                    onPress={() => history.push(`/editBusiness/${currentVenueId}#payments`)}
                    style={{
                      animation: "pulse-glow 2s ease-in-out infinite",
                    }}
                  >
                    <Box
                      bg="red.600"
                      px={3}
                      py={1.5}
                      borderRadius="full"
                    >
                      <Text color="white" fontWeight="bold" fontSize="xs">
                        Connect Payments
                      </Text>
                    </Box>
                  </Pressable>
                )}
                {/* Avatar menu — only once profile data is available */}
                {profile.isLoaded && (
                  <Menu
                    zIndex={9999}
                    w="190"
                    trigger={(triggerProps) => (
                      <Pressable
                        zIndex={9999}
                        accessibilityLabel="More options menu"
                        {...triggerProps}
                      >
                        <Avatar
                          source={{ uri: profile.avatarUrl ? profile.avatarUrl : null }}
                        >
                          {profile.displayName
                            ? profile.displayName.toUpperCase().charAt(0)
                            : "*"}
                        </Avatar>
                      </Pressable>
                    )}
                  >
                    <Menu.Item
                      zIndex={9999}
                      onPress={() => {
                        dispatch({ type: "SETDEFAULT", payload: null });
                        history.push("/Home");
                      }}
                    >
                      Switch Business
                    </Menu.Item>
                    <Menu.Item
                      zIndex={9999}
                      onPress={() => history.push("/account")}
                    >
                      Account Management
                    </Menu.Item>
                  </Menu>
                )}

                <Tooltip title="Not necessary for security but ensure you remember login details or they're shared with necessary staff first." arrow>
                  <span>
                    <Button
                      onPress={() => dispatch(Logout(history))}
                      colorScheme={"danger"}
                      leftIcon={
                        <Icon as={MaterialIcons} name="login" size="sm" color="white" />
                      }
                    >
                      Logout
                    </Button>
                  </span>
                </Tooltip>
              </HStack>
            )}
          </HStack>
          </Box>

        </HStack>
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
  };
};
export default compose(connect(mapStateToProps))(Header);
